import { createContext, useContext } from 'react';

/** InstantDB `i.date()` may surface as ISO string or epoch ms depending on path/version. */
export type TaskRowCompletedAtInput = string | number | Date;

const defaultFormatCompletedAt = (completedAt: TaskRowCompletedAtInput): string => new Date(completedAt).toLocaleTimeString();

/** Override in Storybook when a deterministic caption is required (e.g. Loki vs CI TZ). */
export const TaskRowCompletionTimeContext = createContext<(completedAt: TaskRowCompletedAtInput) => string>(defaultFormatCompletedAt);

export function useTaskRowCompletionTimeFormat(): (completedAt: TaskRowCompletedAtInput) => string {
    return useContext(TaskRowCompletionTimeContext);
}
